// This needs to be just a default export or the metintl tool will blow up
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  addMilestonesModal: {
    btnLabel: "Add Milestones",
    error: "Error Saving Project",
    fromProject: "Current Project Milestones",
    fromProjectTemplate: "VIGOR (Default) Milestones",
    noneAvailable: "No available Milestones for this project",
    saved: "Project Saved",
    targetSchedule: "Target Schedule",
    title: "Add Milestones to a Project"
  },
  addScheduleModal: {
    addNew: "Add Schedule",
    confirmDelete: "Delete this schedule?",
    confirmExtended: "Deleting this schedule will also delete all of it's milestone data.",
    description: "You can add, delete, and name schedules here.",
    dupeMessage: "Cannot save 2 schedules with the same name.",
    error: "Error Saving Schedule",
    errorAdd: "Failure to add schedules: {names}",
    errorDelete: "Failure to delete schedules: {names}",
    errorRename: "Failure to rename schedule: {names}",
    saved: "Schedule Saved",
    selectMilestone: "Select Milestone",
    startSchedule: "Start {scheduleName} at",
    title: "Add/Edit Schedules"
  },
  adminConfig: {
    backdating: {
      cardTitle: "Backdating",
      description: "Configure how far into the past project leaders can backdate milestone actual dates once a project is active.",
      fieldHelp: "Maximum number of days in the past that project leaders (PLs) can set or edit milestone dates on active projects.",
      fieldLabel: "Backdate Window (Days)",
      saveError: "Unable to save backdating settings. Please try again.",
      saveSuccess: "Backdating settings saved.",
      validation: {
        range: "Value must be between {min} and {max} days.",
        required: "Enter a value between 0 and 999 days."
      }
    },
    title: "Admin Config"
  },
  approvalWorkFlows: {
    addApproverLabel: "Add Approver",
    addApproverMessage: "This will make this person need to approve the project type before it proceeds",
    addDependentApproverLabel: "Add Dependent Approver",
    addIndependentApproverLabel: "Add Independent Approver",
    addTitle: "Add Approval Workflow",
    approvalFlowLabel: "Approval Flow",
    approverLabel: "Approver",
    approverSubTitle: "Add a dependent or independent approver. A dependent approver will allowed to approve only after the parent approver has approved the item. Independent approvers are sent out simultaneously.",
    deleteApproverModalDescription: "You cannot undo this action, are you sure you want to proceed?",
    deleteApproverModalTitle: "Delete Approver Confirmation",
    deleteWorkFlowModalDescription: "You cannot undo this action, are you sure you want to proceed?",
    deleteWorkFlowModalTitle: "Delete Approval WorkFlow Confirmation",
    dependencyLabel: "Dependency",
    dependentLabel: "Dependent on ",
    dependentMessage: "Indicates the approver is dependent on the parent approver completing their approval",
    dupNameError: "Duplicate Name Found",
    dupProjectTypeError: "Project type already mapped to existing approval workflow",
    editTitle: "Edit Approval Workflow",
    gridColumns: {
      name: "Name",
      projectType: "Project Type"
    },
    independentLabel: "Independent",
    nameLabel: "Name",
    projectTypesLabel: "Project Types",
    selectApproverPlaceholder: "Select a Approver",
    selectProjectTypesPlaceholder: "Select Project Types",
    title: "Approval Workflows"
  },
  baselineDates: {
    actionDelete: "Delete this date?",
    addNew: "Add New",
    colDates: "Dates",
    colProductCategory: "Product Category",
    colProjectType: "Project Type",
    currentDateRange: "Current",
    deleteError: "Error deleting baseline date",
    deleteModalDescription: "Are you sure you want to delete the review date schedule for this project type and product category?",
    deleteModalTitle: "Delete Review Date Schedule Confirmation",
    deleteSuccess: "Baseline dates deleted",
    editTitle: "Baseline Date Select",
    requiredProductCategory: "Product Category is required",
    requiredProjectType: "Project Type is required",
    saveError: "Error saving baseline date",
    saveSuccess: "Baseline dates saved",
    selectedDates: "Selected Dates",
    title: "Baseline Dates"
  },
  changeStatusModal: {
    cannotComplete: "Open milestone(s) exist on this project, cannot mark as complete.",
    change: "Change",
    contactAdmin: "Submit a service ticket if a status change is needed for this project",
    description: "Change the project status.",
    error: "Error Saving Project Status",
    intakeCanceledWarning: "Warning: You are canceling this intake, once canceled, you will be unable to add, update, or delete documents, perform any other action on this intake or in the Team in MS Teams.",
    projectCanceledWarning: "Warning: You are canceling this project, once canceled, you will be unable to add, update, or delete documents, milestones, team members, or perform any other action on this project or in the Team in MS Teams.",
    saved: "Project Status Saved",
    title: "Change Status"
  },
  comments: {
    addComment: "Add Comment",
    approverReplaceTitle: "Add Approver Replace Reason",
    comment: "Comment",
    commentSuccess: "Comment Added",
    error: "Error occurred while posting the comment",
    internal: "Internal Only",
    noValue: "Please add a comment",
    post: "Post",
    reply: "Reply",
    replyToComment: "Reply to Comment",
    tag: "Tag"
  },
  conditionalAccess: {
    grantReadOnlyAccess: "Grant Read Only Access",
    hideImages: "Hide Images",
    listCartTitle: "Groups",
    members: "Members ({count})",
    name: "Name",
    onlyAssigned: "Has Rules",
    onlyAssignedTooltip: "Only groups with rules",
    productCategoriesHelp: "No selected categories means all categories",
    productCategoriesPlaceholder: "All",
    projectTypes: "Project Types",
    saved: "Group Saved",
    searchTooltip: "Search by group name",
    showImages: "Show Images",
    title: "Conditional Access"
  },
  confirmDuplicateFormPropertyValuesModal: {
    cancel: "Return to Edit",
    formPropertyLocationValue: "Duplicate Location Option Values",
    formPropertyUserValue: "Duplicate User Option Values",
    formPropertyValue: "Duplicate Option Values",
    modalTitle: "Confirm Duplicate Form Options",
    saveAnyway: "Save with Duplicates"
  },
  dashboard: {
    collapseAll: "Collapse All",
    expandAll: "Expand All",
    customize: {
      allHidden: "All dashboard widgets are hidden.",
      button: "Customize",
      drag: "Drag to reorder",
      hide: "Hide",
      openCustomize: "Customize Dashboard",
      reset: "Reset to Default",
      show: "Show",
    },
    columns: {
      abbreviation: "Abbr.",
      actualDate: "Actual",
      actualCurrentDate: "Actual/Current",
      approve: "Approve",
      approver: "Approver",
      approverName: "Approver Name",
      approverRole: "Approver Role",
      dateApproved: "Date Approved",
      dateAssigned: "Date Assigned",
      days: "Days",
      daysSinceUpdated: "Days Since Updated",
      department: "Department",
      financeApprovalGroup: "Finance Approval Group",
      functionalArea: "Functional Area",
      intake: "Intake",
      intangibleAccountingStandard: "IAS",
      milestone: "Milestone",
      myProjectRole: "Your Role",
      parentMilestone: "Parent Milestone",
      platformProject: "Platform",
      productCategory: "Product Category",
      productLine0: "Product Line 0",
      productLine1: "Product Line 1",
      productLine2: "Product Line 2",
      projectName: "Project Name",
      projectNumber: "Project #",
      projectRole: "Project Role",
      projectType: "Project Type",
      schedule: "Schedule",
      status: "Status",
      target: "Target",
      type: "Type",
      view: "View"
    },
    titles: {
      keyMilestones: "Key Milestones",
      myDashboard: "My Dashboard",
      pendingIntakeApprovals: "Pending Intake Approvals",
      pendingMilestoneApprovals: "Pending Milestone Approvals",
      recentlyApprovedIntake: "Recently Approved Intakes",
      recentlyApprovedMilestones: "Recently Approved Milestones",
      routingMilestoneApprovals: "Routing Milestone Approvals"
    }
  },
  editForm: {
    actionDelete: "Delete this field?",
    addDependentFieldButton: "Add Dependent",
    addFieldButton: "Add Field",
    colActions: "Actions",
    colCategory: "Category",
    colDependentValues: "Dependent Values",
    colFieldLabel: "Field Label",
    colFieldName: "Field Name",
    colFieldType: "Field Type",
    colOrder: "Order",
    colStatus: "Status",
    contentSubTitle: "You can add any number of custom fields to the form.",
    contentTitle: "Manage fields for the {formType} form",
    couldNotReloadForm: "{formType} form could not be reloaded.",
    fieldDeleted: "{field} field successfully deleted.",
    hideInactiveFields: "Hide Inactive Fields",
    pageTitle: "Edit Form",
    productCategory: "Product Category",
    showInactiveFields: "Show Inactive Fields",
    sort: "Sort",
    sortSaved: "New sort order saved successfully."
  },
  editFormField: {
    contentSubTitle: "You can change the information of this form field",
    contentTitle: "Edit Field",
    pageTitle: "Edit Form Field"
  },
  editKpiStatusModal: {
    change: "Change",
    error: "Error Saving KPI Status",
    saved: "KPI Status Saved",
    title: "Change Status of {kpiLabel}"
  },
  editMilestonesModal: {
    error: "Error Saving Project",
    name: "Name",
    saved: "Project Saved",
    title: "Edit Milestone"
  },
  editProjectTemplate: {
    add: "Add Milestones",
    addMilestoneModal: {
      permissionApprovalRequired: "Approval Needed?",
      permissionCanBeAdded: "Can Be Added?",
      permissionCanBeDeleted: "Can Be Deleted?",
      permissionCanBeSkipped: "Can be Skipped?",
      permissionDefaultFor: "Default"
    },
    addMilestoneModalTitle: "Add Milestone to Project Template",
    addProjectLeaderApprovers: "Add Project Leader Approver",
    addProjectLeaderNotifications: "Add Project Leader Notification User",
    approversHeader: "Approvers",
    editMilestone: {
      editMilestoneModalTitle: "Edit Milestone"
    },
    hideDisabledSwitch: "Hide Disabled",
    isCtqDisabledLabel: 'Hide "View in CTQ" link on projects',
    kpiErrorMessageHigh: "Only {count} KPI Indicators can be selected.",
    kpiErrorMessageLow: "{count} KPI Indicators must be selected.",
    kpiIndicators: "KPI Indicators",
    milestoneAttributes: {
      areProjectSkusRequired: "Project Sku(s) Required",
      areProjectSkusRequiredTooltip: "Enabling will require subsequent milestones to require a SKU.",
      milestoneDocumentsRequired: "Document(s) Required",
      targetDatesRequired: "Target Date Required on Major Milestones"
    },
    milestoneAttributesHeader: "Milestone Attributes",
    milestoneDetails: {
      all: "All",
      enabled: "Enabled",
      false: "No",
      notificationGroup: "Group",
      notificationRole: "Role",
      permissionApprovalRequired: "Approval Needed",
      permissionCanBeAdded: "Can Add",
      permissionCanBeDeleted: "Can Delete",
      permissionCanBeSkipped: "Can Skip",
      permissionDefaultFor: "Default",
      true: "Yes"
    },
    milestoneModal: {
      canSetNotApplicable: "Set N/A",
      colFunctionalArea: "Functional Area",
      colName: "Name",
      colRegion: "Region",
      colRequired: "Required",
      colType: "Type",
      coreTeam: "Core Team",
      coreTeamGroupName: "Core Team Group",
      functionalArea: "Add Role to Functional Area",
      groupName: "Notification Group",
      notificationGroups: "Notification Groups",
      roleName: "Role",
      searchNotificationGroups: "Search Groups",
      searchRoles: "Search Roles"
    },
    milestones: "Milestones",
    notificationsHeader: "Notification Roles/Groups",
    pageTitle: "Project Templates",
    permissionsHeader: "Permissions",
    projectLeaderApprovers: "Project Leader Approvers",
    projectLeaderNotification: "Project Leader Notification",
    saveError: "Error saving Project Template",
    saveErrorMilestoneCompletionData: "Error saving Project Template. Milestone Completion data is improperly configured.",
    saveSuccess: "Project Template saved",
    toggleChecked: "Close All",
    toggleUnchecked: "Open All",
    urlErrorMessage: "This field must be a valid url.",
    urlHttpErrorMessage: "Urls must start with http:// or https://",
    urlRequiredError: "A VIGOR template URL is required",
    vigorTemplatesTitle: "VIGOR Templates",
    vigorTemplatesUrl: "URL"
  },
  entityStatusInput: {
    noMilestones: "No Milestones Found.  You must assign at least one project complete milestone.",
    noProjectCompleteMilestone: "No Active Project Complete Milestone Found."
  },
  enum: {
    entityStatus: {
      active: "Active",
      inactive: "Inactive",
      preview: "Preview"
    },
    entityStatus_abbreviation: {
      active: "A",
      inactive: "I",
      preview: "P"
    },
    fieldType: {
      attachment: "Attachment",
      autocomplete: "Auto Complete",
      checkbox: "Checkbox",
      date: "Date",
      daterange: "Date Range",
      dropdown: "Drop Down",
      multiattachment: "Multiple Attachments",
      multiselectautocomplete: "Multi-Select Auto Complete",
      multiselectdropdown: "Multi-Select Drop Down",
      number: "Number",
      percentcompleteslider: "Percent Complete Slider",
      radiobutton: "Radio Button",
      switch: "True/False Switch",
      text: "Text",
      textarea: "Text Area",
      textareawithmentions: "Text Area with @Tagging"
    },
    fileType: {
      any: "Any File Type",
      audio: "Audio",
      autoCAD: "AutoCAD",
      csv: "Comma Separated File",
      excel: "Excel",
      images: "All Image Types",
      pdf: "Pdf",
      pngs: "Pngs Only",
      videos: "Videos",
      word: "Word"
    },
    formType: {
      intake: "Intake"
    },
    roles: {
      Admin: {
        description: "Can make changes to their own items as well as items owned under their hierarchy",
        short: "Administrator"
      },
      PLRequestor: {
        description: "Owner of a project",
        short: "Project Lead Requestor"
      },
      SuperAdmin: {
        description: "Highest level of privilege.  Can make changes system wide",
        short: "Super Admin"
      },
      Watcher: {
        description: "Read-Only access to a project",
        short: "Watcher"
      }
    }
  },
  errorPage: {
    clickHere: "Click Here",
    contactText: "To contact the IT Service Desk,",
    emailText: "to submit a ticket or Email",
    goToDashboard: "Return to VIPER Home Page",
    helpDeskEmail: "ITServiceDesk@milwaukeetool.com."
  },
  errors: {
    contactIT: "Contact the IT Service Desk",
    default: "Please contact your system admin for assistance.",
    invalidDateRange: "Date range provided is invalid.",
    invalidFilter: "Your filter is invalid",
    invalidSearch: "Your search is invalid",
    invalidSearchField: "Your search contains an invalid field",
    pageNotFound: "This page does not exist. If you think this was in error, please try again later. If this persists, please contact IT Service desk.",
    serverError: "There is a technical issue, please try again later. If this persists, please contact IT Service desk.",
    unauthorized: "You do not have access to this page. If you think this is in error, please contact the IT service desk for assistance."
  },
  footer: {
    legal: "Legal",
    privacyPolicy: "Privacy Policy"
  },
  formSelection: {
    intakeForm: "Intake Form",
    pageTitle: "Forms"
  },
  general: {
    actions: "Actions",
    active: "Active",
    add: "Add",
    advanced: "Advanced",
    all: "All",
    allProjects: "All Projects",
    approve: "Approve",
    approved: "Approved",
    cancel: "Cancel",
    clearAll: "Clear All",
    clearFilters: "Clear Filters",
    close: "Close",
    columns: "Columns",
    comments: "Comments",
    costCenter: "Cost Center",
    create: "Create",
    default: "Default",
    delete: "Delete",
    details: "Details",
    download: "Download",
    edit: "Edit",
    entityIsNoLongerAvailable: "{entity} is no longer available.",
    error: "An error occurred",
    export: "Export",
    failedToRetrieve: "Failed to retrieve",
    failedToRetrieveEntity: "Failed to retrieve {entity}.",
    false: "False",
    fieldRequiredMessage: "* Fields Required for Submittal",
    filter: "Filter",
    history: "History",
    inactive: "Inactive",
    loginError: "Could not be logged in.",
    makeDefault: "Make Default",
    myProjects: "My Projects",
    nameValidationError: "Name cannot begins with spaces. Please enter a valid name.",
    no: "No",
    noData: "No Data",
    noResultsFound: "No results found",
    none: "None",
    notApplicable: "N/A",
    ok: "Ok",
    on: "on",
    options: "Options",
    preview: "Preview",
    productCategories: "Product Categories",
    reject: "Reject",
    reorder: "Reorder",
    replace: "Replace",
    reset: "Clear Search Values",
    resultLabel: "Results: {current} of {total}",
    save: "Save",
    search: "Search",
    searchIndexInfoMessage: "Newly added records may take several seconds to appear in searches and listing pages.  If you do not see this item, please wait a moment and refresh your page.",
    searchPlaceholder: "Search...",
    searchTips: "Search Tips",
    select: "Select",
    status: "Status",
    submit: "Submit",
    tenant: "Tenant",
    toastChangesSaved: "Your changes have been saved.",
    toastSomethingWentWrong: "Something went wrong. Please try again later.",
    true: "True",
    tryAgain: "Try Again",
    unknown: "Unknown",
    unknownUser: "Unknown User",
    unsavedChangesOverwrite: "You have unsaved changes. Duplicating from another project will overwrite these.  Do you want to continue?",
    unsavedChangesTitle: "Unsaved Changes",
    uploadError: "Error Uploading File",
    uploadFile: "Click or drag file to this area to upload",
    uploadsFailedTryAgain: "Upload(s) failed, please try again.",
    uploadsWaitForAllToComplete: "Please wait for your file(s) to finish uploading.",
    validationError: "Validation Error:\n{message}",
    viewTable: "View Table",
    warning: "Warning: ",
    yes: "Yes"
  },
  history: {
    Project: {
      KeyPerformanceIndicators: {
        Cost: "Cost",
        Performance: "Performance",
        Risk: "Risk",
        Savings: "Savings",
        Schedule: "Schedule",
        changeDescription: "KPI {indicator} changed from {oldValue} to {newValue}.",
        deleteChangeDescription: "KPI {indicator} removed.",
        insertChangeDescription: "KPI {indicator} added with value {newValue}."
      },
      ProjectKpiStatuses: {
        Gray: "Gray",
        Green: "Green",
        Red: "Red",
        Yellow: "Yellow"
      }
    },
    ProjectImage: {
      deleteChangeDescription: "Project Image was deleted.",
      insertChangeDescription: "Project Image was inserted."
    },
    ProjectMilestone: {
      DisplayName: "Display Name",
      deleteChangeDescription: "Milestone was deleted.",
      insertChangeDescription: "Milestone was inserted."
    },
    ProjectMilestoneRole: {
      assignedUsers_added: "Added {users}.",
      assignedUsers_approvalReset: "{users} approval reset.",
      assignedUsers_approved: "{users} approved.",
      assignedUsers_removed: "Removed {users}.",
      deleteChangeDescription: "Removed approval role.",
      insertChangeDescription: "Assigned {users}."
    },
    ProjectRole: {
      AssignedUsers: "Assigned Users",
      IsCoreTeam: "Core Team",
      deleteChangeDescription: "Removed approval role.",
      insertChangeDescription: "Added {users}."
    },
    StockKeepingUnit: {
      Name: "Name",
      deleteChangeDescription: "Sku removed {name}.",
      insertChangeDescription: "Sku added {name}."
    },
    WorkflowHistory: {
      CurrentStatus: {
        Approved: "Approved",
        Rejected: "Rejected"
      },
      changeDescription: "{CurrentStatus} Project Intake."
    },
    genericPropertyChangeDescription: "{PropertyName} changed from {OldValue} to {NewValue}.",
    nothing: "nothing"
  },
  historyLog: {
    ActionCol: "Action",
    addUsersChange: "Add Users: {user} {action}",
    added: "added",
    approverChange: "Approver: {role} {action}",
    changeSummary: " changed from {oldValue} to {newValue}",
    changedByCol: "Changed By",
    create: "Create",
    createPastTense: "created",
    dateCol: "Date",
    delete: "Delete",
    deletePastTense: "deleted",
    excludeUsersChange: "Exclude Users: {user} {action}",
    fieldChange: "Field {action}",
    newValueCol: "New Value",
    oldValueCol: "Old Value",
    optionsChange: "Options {action} for {option}",
    permissionChange: "Permission {action}",
    permissionStatusChange: "Permissions for {permission} for {action}",
    propertyCol: "Property",
    removed: "removed",
    restore: "Restore",
    restorePastTense: "restored",
    summaryCol: "Summary",
    update: "Update",
    updatePastTense: "updated",
    userReplacementChange: "Replace {user} with {replacement}"
  },
  home: {
    activeProjects: "Active Projects",
    approvalsRemaining: "Approvals Remaining",
    approvedProjectTitle: "In Milestone Approval",
    approverColText: "Approver",
    dashboard: {
      title: "VIPER Dashboard"
    },
    dashboardTitle: "VIPER Dashboard",
    daysColText: "Days",
    email: "Email",
    groups: "Groups",
    milestonesOverdue: "Milestones Overdue",
    name: "Name",
    pastDueColText: "Past Due",
    projectNumberColText: "Project #",
    roles: "Roles",
    sampleChart: "Sample Chart",
    submittedProjectTitle: "In Finance Approval",
    typeColText: "Type",
    users: "Users"
  },
  initiative: {
    createPageTitle: "Create Initiative",
    keyInformation: "Key Information",
    opportunityName: "Opportunity Name",
    editPageTitle: "Edit Initiative",
    estimatedTargetLaunchDate: "Estimated Target Launch Date",
    requiredFields: "Required Fields",
    osaStyleDocumentation: "OSA Style Documentation",
    documentsRequiredMessage: "At least one document is required",
    documentsUploading: "Please wait for all documents to finish uploading before saving",
    saveError: "Error saving Initiative",
    saveSuccess: "Initiative saved",
    saveBeforePreview: "You must save the initiative before you can preview this file",
    unsavedChangesTitle: "Unsaved Changes",
    unsavedChangesMessage: "You have unsaved changes on this page. Are you sure you want to leave without saving?",
    createInitiative: "Create Initiative",
    title: "Initiatives",
    columns: {
      name: "Name",
      status: "Status",
      projectType: "Project Type"
    },
    status: {
      opportunity: "Opportunity",
      roadMapped: "Road Mapped"
    }
  },
  kpiLabels: {
    cost: "Cost",
    performance: "Performance",
    risk: "Risk",
    savings: "Savings",
    schedule: "Schedule"
  },
  layout: {
    allDepartmentsLabel: "[All Departments]",
    allJobTitlesLabel: "[All Job Titles]",
    departmentInputLabel: "Department:",
    descriptionInputLabel: "Description",
    detailsCardTitle: "Details",
    jobTitleInputLabel: "Job Title:",
    nameInputLabel: "Name"
  },
  milestoneCompleteModal: {
    content: "Upon approving/releasing this milestone, the project will be completed. You will be unable to add, update, or delete documents, milestones, team members, or perform any other action on this project.",
    continue: "Continue",
    submitForApproval: "Warning: You are submitting this milestone for approval, once approved, the project will be completed. You will be unable to add, update, or delete documents, milestones, team members, or perform any other action on this project.",
    title: "Project Complete Milestone"
  },
  milestoneDetails: {
    approvers: "Approvers",
    comments: "Comments",
    ctqSnapshots: "CTQ Snapshots",
    documents: "Documents",
    notifications: "Notifications",
    release: "Release"
  },
  milestoneStatusActionCommentModal: {
    approveDescription: "No Comment Required for approval.",
    approveTitle: "Approve",
    overrideDescription: "You have a rejected milestone on your project.  To proceed, a comment is required explaining why this milestone will remain in the rejected state.",
    reenableDescription: "A comment is required when re-enabling a milestone. Please describe the reasons for re-enabling this milestone.",
    reenableTitle: "Re-enable",
    rejectDescription: "A comment is required when rejecting a milestone. Please describe the reasons for rejecting this milestone.",
    rejectTitle: "Reject",
    releaseTitle: "Release",
    skipDescription: "A comment is required when skipping a milestone. Please describe the reasons for skipping this milestone.",
    skipTitle: "Skip",
    skipWarn: "Skipping this milestone will also skip all of it's children.",
    submitforapprovalDescription: "A comment is required when submitting the milestone that will complete the project for approval.",
    submitforapprovalTitle: "Submit For Approval"
  },
  milestoneTemplates: {
    abbreviationDupError: "Duplicate Abbreviation Found",
    abbreviationLabel: "Abbreviation",
    actions: {
      addAfter: "Add After",
      addBefore: "Add Before",
      addChild: "Add Child",
      cancel: "Cancel",
      delete: "Delete",
      duplicate: "Duplicate",
      edit: "Editing",
      editName: "Edit Name/Abbreviation",
      exportRoles: "Export Roles",
      milestones: "Milestones"
    },
    addMilestoneTemplateTitle: "Create Milestone Template",
    addMilestoneTop: "Create Milestone",
    addModalChild: "Create milestone {target} to {name}",
    addModalLocation: "Create milestone {target} {name}",
    buPermissionsAllOrNoneLabel: "All/None",
    buPermissionsLabel: "Product Line Permissions",
    canAddHeader: "Can Add",
    canDeleteHeader: "Can Delete",
    colAbbreviation: "Abbreviation",
    colName: "Name",
    colPublished: "Published",
    columns: {
      abbreviation: "Abbr.",
      approval: "Approval",
      approvalRequired: "App. Req.",
      approversNeeded: "Approval Required with no Approvers Added.",
      canAdd: "Can Add",
      canDelete: "Can Delete",
      canSkip: "Can Skip",
      complete: "Complete",
      date: "Date",
      default: "Default",
      descriptions: {
        active: "Mark this milestone as active, making it available for future projects.",
        approvalRequired: "Choose product categories that require approvers to close this milestone.",
        canAdd: "Choose the product categories where this milestone can be added to projects.",
        canDelete: "Choose the product categories where this milestone can be deleted from projects.",
        canSkip: "Choose the product categories where this milestone can be skipped on projects.",
        complete: 'Select the milestone that, when completed, will mark the project as "Complete." This will also open the visibility to the org.',
        date: "Select the milestone where a target date is required. All subsequent major milestones will also require a target date.",
        default: "Choose the product categories to which this milestone will be automatically assigned on new projects.",
        document: "Select if a document is required for routing or releasing milestone.",
        prepopulateDate: "Select the date field from intake to apply as the target date for this milestone.",
        secure: "Select to secure the project upon completion, only allowing visibility to users with the 'ViewSecureCompletedProjects' permission. \"Complete\" must also be checked.",
        sku: "Select the milestone where a SKU is required. All following milestones will also require a SKU."
      },
      document: "Doc.",
      functionalArea: "Functional Area",
      group: "Group",
      keyMilestone: "Key Milestone",
      name: "Milestone",
      notApplicable: "Set N/A",
      notify: "Notify",
      prepopulateDate: "Intake Date",
      productCategory: "Product Cat.",
      region: "Region",
      required: "Required",
      role: "Role",
      secure: "Secure",
      sku: "SKU",
      status: "Status"
    },
    copyChildrenMilestoneError: "Because the existing milestone you added includes child milestones which would exceed the maximum allowed parent-child depth on a template (which is 3 child milestones deep plus the parent), only the parent of your selected milestone was added to the template.",
    create: "Create Milestone Template",
    createError: "Error creating milestone template",
    createSuccess: "Milestone template created",
    defaultsHeader: "Defaults",
    documentsRequired: "Document(s) Required",
    editMilestoneTemplateTitle: "Edit Milestone Template",
    editModal: {
      approvers: "Approvers",
      notificationGroups: "Notification Groups",
      notificationRoles: "Notification Roles/Groups",
      projectLeaders: "Project Leaders"
    },
    hideChildren: "Hide Children",
    includeAllVersionsCheckboxLabel: "Include All Versions",
    loadingError: "Failed to load milestone template",
    loadingErrorProductLines: "Failed to load product lines",
    nameAbbreviationLabel: "Name and Abbreviation",
    nameDupError: "Duplicate Name Found",
    nameLabel: "Name",
    prepopulateDateConflictMessage: 'Only one milestone per product category can be populated with the same date field. Setting this milestone to prepopulate from "{milestoneDateSource}" will remove that functionality from "{milestoneTemplateName}."',
    prepopulateMilestoneTargetDate: "Prepopulate Milestone Target Date",
    prepopulateSourcesLabel: "Selected Intake Date Field",
    save: "Save Milestone Template",
    saveError: "Error saving milestone template",
    saveSuccess: "Milestone template saved",
    searchError: "Failed to retrieve milestone templates",
    searchHelpText: '<p>Search terms can include name and description</p><p>By default, searches with spaces will treat separate words as AND searches - Ex. <code>ruecker champlin</code> will return groups matching the terms <code>ruecker</code> AND <code>champlin</code>.</p><p>The following modifiers can be used for advanced searching:</p><ul><li><strong>OR operator (<code>||</code>)</strong> - Ex. <code>ruecker||champlin</code> will return groups matching the terms <code>ruecker</code> OR <code>champlin</code></li><li><strong>NOT operator (<code>-</code>)</strong> - Ex. <code>ruecker -champlin</code> will return groups matching the term <code>ruecker</code> but NOT <code>champlin</code></li><li><strong>Suffix operator (<code>*</code>)</strong> - Ex. <code>rue*</code> will return groups matching the term <code>rue</code> and any additional characters. Useful for matching partial words.</li><li><strong>Phrase operator (<code>""</code>)</strong> - Ex. <code>"Test Engineer II"</code> will return groups matching the WHOLE phrase <code>"Test Engineer II"</code> exactly</li></ul>',
    searchTooltip: "Search by template name and abbreviation.",
    secureProjectOnCompletion: "Secure Project on Completion",
    secureProjectOnCompletionHelp: "Secure the project on completion to restrict visibility once the project is completed.",
    shouldCompleteProject: "Should Complete Project",
    shouldCompleteProjectAlertMessage: "Only one milestone may trigger project completion. Setting this milestone to trigger project completion will remove that functionality from {milestoneTemplateName}.",
    shouldCompleteProjectHelp: "Completion of this milestone will trigger the completion of the end of the project.",
    showActive: "Show Active",
    showAll: "Show All",
    showChildren: "Show Children",
    status: "Status",
    targetDatesRequiredAlertMessage: "Only one milestone per product category can require target dates. Setting this milestone to require target dates on major milestones will remove that functionality from {milestoneTemplateName}.",
    title: "Milestone Templates",
    toggleActive: "Active",
    toggleDraft: "Draft"
  },
  milestonesList: {
    addMilestone: "Add",
    all: "All",
    allMilestones: "All Milestones",
    collapse: "Collapse",
    confirmDelete: "Delete this milestone?",
    confirmDeleteProjectMilestoneBody: "Click 'Yes' to confirm deletion.",
    confirmDeleteProjectMilestoneTitle: "Delete this milestone - {milestoneName}?",
    ctqSnapshotCreateErrorDescription: "An error occurred while creating the CTQ snapshot. The SKU may no longer be available in CTQ. Please try again.",
    ctqSnapshotCreateErrorTitle: "Unable to create CTQ snapshot",
    ctqSnapshotDeleteConfirmDescription: "Click 'Yes' to remove this snapshot link.",
    ctqSnapshotDeleteConfirmTitle: "Delete this CTQ snapshot?",
    ctqSnapshotDeleteErrorDescription: "An error occurred while deleting the CTQ snapshot. Please try again.",
    ctqSnapshotDeleteErrorTitle: "Unable to delete CTQ snapshot",
    delete: "Delete",
    edit: "Edit",
    editDateWarning: "Target/Actual dates cannot be set earlier than {count} days prior to today's date.",
    expand: "Expand",
    expandTooltip: "Expand/Collapse Milestone Details",
    getCtqSkus: "Get CTQ SKUs",
    loadingMilestone: "Milestones are currently being created automatically",
    milestoneActiveApproversRequiredError: "{milestoneName} contains an inactive user.",
    milestoneActiveNotificationUsersRequiredForApprovalError: "{milestoneName} cannot be approved because a notification user is no longer available.",
    milestoneActiveNotificationUsersRequiredForReleaseError: "{milestoneName} cannot be released because a notification user is no longer available.",
    milestoneActualDateError: "{milestoneName} requires actual date.",
    milestoneApproverError: "{milestoneName} requires all approval roles to be filled out.",
    milestoneApproversRequiredError: "{milestoneName} requires an approver.",
    milestoneDeleteDocumentError: "{milestoneName} can not be deleted before deleting documents.",
    milestoneDeleteErrorDescription: "These items need to be fixed before you can delete this milestone.",
    milestoneDeleteErrorTitle: "{milestoneName} Not Deleted",
    milestoneDeleteStatusError: "{milestoneName} is not in Draft Status.",
    milestoneDeleted: "Milestone deleted",
    milestoneDeletedError: "Error in deleting this milestone.",
    milestoneDocumentError: "{milestoneName} requires a document.",
    milestoneNotificationUsersRequiredError: "{milestoneName} requires a notification user.",
    milestoneProjectCompleteError: "You are unable to release/route this milestone at this time. There are milestones on your project (yellow icons) that are currently in a workflow. Please have those milestones approved and then you will be able to release/route this milestone.",
    milestoneReleaseDescription: "These items need to be fixed or completed before you can release this milestone.",
    milestoneReleaseTitle: "{milestoneName} Not Released",
    milestoneSaveApproverReplaceDescription: "Please fill out all required approver roles to save.",
    milestoneSaveApproverReplaceTitle: "Required Approver Role Needs Approver",
    milestoneSkusError: "{milestoneName} requires at least one SKU set on project.",
    milestoneSubmitForApprovalDescription: "These items need to be fixed or completed before you can submit this milestone.",
    milestoneSubmitForApprovalTitle: "{milestoneName} Not Submitted",
    milestoneTargetDateRequiredError: "{milestoneName} requires a target date.",
    milestoneTargetDatesRequiredError: "{milestoneName} requires that all top level milestones in Draft or Rejected state have target dates.",
    moveToDraft: "Move To Draft",
    noCtqSkusAvailable: "There are no SKUs to select.",
    projectCompleteAttribute: "PC",
    projectCompleteAttributeTooltip: "Project Complete",
    projectCompleteSecureAttribute: "PCS",
    projectCompleteSecureAttributeTooltip: "Project Complete Secure",
    reenable: "Re-enable",
    release: "Release",
    skip: "Skip",
    skuRequiredAttribute: "SKU",
    skuRequiredAttributeTooltip: "SKU Required",
    statusChangeError: "Error Updating Status on Milestone",
    statusChangeSuccess: "Milestone Status Updated",
    submitForApproval: "Submit for Approval",
    targetDatesRequiredAttribute: "TDR",
    targetDatesRequiredAttributeTooltip: "Target Dates Required",
    toggleChecked: "Close",
    toggleUnchecked: "Open",
    top: "Top",
    topTooltip: "Show Top/All Milestones"
  },
  navbar: {
    adminConfig: "Admin Config",
    administration: "Administration",
    apiDocs: "API",
    apiDocumentation: "API Documentation",
    approvalWorkFlows: "Approval Workflows",
    backdating: "Backdating",
    baselineDates: "Baseline Dates",
    conditionalAccess: "Conditional Access",
    dashboard: "Dashboard",
    forms: "Forms",
    general: "General",
    goTo: "Go To",
    grs: "GRS",
    initiatives: "Initiatives",
    lrs: "LRS",
    main: "Main",
    milestones: "Milestones",
    misc: "Misc",
    notificationGroups: "Notification Groups",
    performance: "Performance",
    permissions: "Permissions",
    powerBI: "PowerBI",
    preferences: "Preferences",
    projectRoles: "Project Roles",
    projectTemplates: "Project Templates",
    projects: "Projects",
    settings: "Settings",
    signOut: "Sign Out",
    timeTracker: "Time Tracker",
    userManagement: "User Management",
    userReplacement: "User Replacement",
    users: "Users"
  },
  newFormField: {
    addLocation: "Add Location",
    addNextStatus: "Add Next Status",
    addOption: "Add Option",
    addProcess: "Add Process",
    addUser: "Add User",
    addVendor: "Add Vendor",
    allowedFileTypes: "Allowed File Types",
    canDeleteRequest: "Can Delete Request",
    category: "Category",
    categoryPlaceHolder: "Select a Category",
    changeFieldTypeButton: "Change Field Type",
    contentSubTitle: "You can add any number of custom fields to the form.",
    contentTitle: "Create New Field",
    defaultPermissionsPlaceholder: "Default Field Permissions",
    dependentValuesPlaceholder: "Hit 'enter' after each value",
    dependentValuesTitle: "Dependent Values (Optional)",
    endDateValidationField: "Field for end date limit",
    endpoint: "Endpoint",
    endpointRequired: "Endpoint Required",
    endpoint_departments: "Departments",
    endpoint_users: "Users",
    fieldHistoryLabel: "Track History",
    fieldLabel: "Field Label",
    fieldLabelRequired: "Field Label Required",
    fieldNameErrorMessage: "Field name already exists. Please change the field name.",
    fieldTypeTitle: "Field Type",
    formTypeTitle: "Form Type",
    includeTime: "Include Time Picker",
    lockAfterSubmitTitle: "Lock field after submission",
    maintainedBy: "Maintained By",
    maintainedByPlaceholder: "Hit 'enter' after each value",
    maxCharacterLength: "Max Character Length",
    name: "Name",
    notifyAssigned: "Notify Assigned",
    notifyRequester: "Notify Requester",
    numberMax: "Max",
    numberMin: "Min",
    numberPrecision: "Precision",
    option: "Option",
    optionLabelPlaceholder: "Option Label",
    optionLabelRequired: "Option Label Required",
    optionStatusDefaultForProductCategory: "Default Selected Value For Product Categories",
    optionStatusDefaultForProductCategoryPlaceholder: "None",
    optionStatusNextStatusButtonTextPlaceholder: "Button Text",
    optionStatusNextStatusButtonTextRequired: "Button Text Required",
    optionStatusNextStatusPermissionsPlaceholder: "All Users",
    optionStatusNextStatusStatusPlaceholder: "Status",
    optionStatusNextStatusStatusRequired: "Next Status Required",
    optionTaskNumberPlaceholder: "Task Number",
    optionUserPlaceholder: "User",
    optionUserRequired: "User Required",
    optionVendorPlaceholder: "Vendor",
    optionVendorRequired: "Vendor Required",
    options: "Options",
    optionsOrder: "Order",
    pageTitle: "New Form Field",
    parentFieldTitle: "Parent Field",
    permissionsPlaceholder: "Select permissions (optional)",
    permissionsTitle: "Permissions",
    placeholder: "Placeholder Text",
    productCategoryPlaceHolder: "Empty to select all",
    requireParts: "Require Parts",
    requireProcesses: "Require Processes",
    requiredForStatuses: "Required For Statuses",
    requiredForStatusesPlaceholder: "Hit 'enter' after each value",
    setDefaultPermissions: "Set Default Permissions",
    sortOptions: "Sort Options",
    startDateValidationField: "Field for start date limit",
    status: "Status",
    statusOptionsMessage: 'Cannot add "Status" options until field is saved. Either Save and add statuses in "Edit" or change the field name and reselect the field type.',
    timeDependentValues: "Time Picker Dependent Values (Optional)",
    timeParentField: "Parent Field for Time Picker",
    validationErrorText: "Validation Error Text"
  },
  newProjectType: {
    pageTitle: "New Project Type"
  },
  notificationGroups: {
    actionDelete: "Delete this group?",
    addModalTitle: "Add Notification Group",
    colEmail: "Email",
    colName: "Name",
    editModalTitle: "Edit Notification Group",
    pageTitle: "Notification Groups",
    searchGroupPlaceholder: "Search...",
    selectGroupLabel: "Name / Email",
    tableTitle: "Notification Groups",
    toastSuccessfulDelete: "Successfully deleted Notification Group"
  },
  pageErrors: {
    accessDeniedTitle: "Access Denied",
    contactSystemAdmin: "If you believe you have encountered this page by mistake, please contact your system administrator.",
    loginErrorTitle: "Error Logging In",
    pageNotFoundTitle: "Page Not Found"
  },
  permissions: {
    addAdGroupsSubtitle: "Add user groups to this permission.",
    addAdGroupsTitle: "Add AD Groups",
    addUsersCardSubtitle: "Add individual users to this permission.",
    addUsersCardTitle: "Add Users",
    allDepartmentsLabel: "[All Departments]",
    allJobTitlesLabel: "[All Job Titles]",
    cancelProjects: "Manually cancel a project.",
    changeProjectStatus: "Manually changes a project's status.",
    colDescription: "Description",
    colName: "Name",
    completeProjects: "Manually complete a project.",
    createIntake: "Create and Submit Intakes",
    createProjectMilestone: "Add new milestones to a project.",
    createProjects: "Create new projects.",
    deletePermissionModalDescription: "You cannot undo this action, are you sure you want to proceed?",
    deletePermissionModalTitle: "Delete permission confirmation",
    deleteProjectMilestone: "Delete a un-submitted milestone on a project.",
    departmentInputLabel: "Department:",
    detailsCardTitle: "Details",
    duplicateUserFoundDescription: "That user was found in the other list, do you wish to swap them to this list?",
    duplicateUserFoundTitle: "Duplicate User Found",
    editCompletedProject: "Allow Editing of Project Documents after project is completed/cancelled",
    editCompletedProjectMilestone: "Can Edit completed milestones, will include editing anything on the milestone.",
    editForm: "Can Edit and Create forms for Ideas, Projects, etc.",
    editProjectMilestone: "Edit milestones before being submitted for approval.",
    editProjectMilestoneDates: "Edit milestone dates before submitted for approval.",
    excludeUsersSubTitle: "Users to be excluded from this permission",
    excludeUsersTitle: "Exclude Users",
    getPermissionAdGroupsErrorMessage: "Unable to retrieve AD Groups manually assigned to permission. Please try again later.",
    getPermissionErrorMessage: "Unable to retrieve permission. Please try again later.",
    getPermissionUsersErrorMessage: "Unable to retrieve users manually assigned to permission. Please try again later.",
    getPermissionUsersExcludedErrorMessage: "Unable to retrieve users manually assigned to permission. Please try again later.",
    getRightsErrorMessage: "Unable to retrieve RIGHTS. Please try again later.",
    impersonateUsers: "Impersonate another user.",
    includeDeleted: "Include Deleted",
    jobTitleInputLabel: "Job Title:",
    massReplaceUsers: "Can mass replace users",
    noSearchResultsMessage: "No permissions match the search criteria from above.",
    permissionDescriptionInputLabel: "Permission Description:",
    permissionNameInputLabel: "Permission Name:",
    publishTemplates: "Can publish an unpublished templates.",
    readAllProjects: "Read all project information.",
    readApiDocumentation: "Read the Viper API Documentation.",
    readApprovalWorkFlows: "Can see all the approval workflows.",
    readBaselineDates: "Read all baseline dates",
    readNotificationGroups: "Read all notification groups",
    readPermissions: "Read all permissions.",
    readTemplates: "Can see all the project/milestone templates.",
    readUsers: "Read all users' full Viper profile.",
    replaceProjectUsers: "Can replace individual users on a single project",
    resetProjectMilestoneStatus: "Can set the milestone status back to ready.",
    rightsCardTitle: "Rights",
    searchHelpText: '<p>Search terms can include name and description</p><p>By default, searches with spaces will treat separate words as AND searches - Ex. <code>ruecker champlin</code> will return permissions matching the terms <code>ruecker</code> AND <code>champlin</code>.</p><p>The following modifiers can be used for advanced searching:</p><ul><li><strong>OR operator (<code>||</code>)</strong> - Ex. <code>ruecker||champlin</code> will return permissions matching the terms <code>ruecker</code> OR <code>champlin</code></li><li><strong>NOT operator (<code>-</code>)</strong> - Ex. <code>ruecker -champlin</code> will return permissions matching the term <code>ruecker</code> but NOT <code>champlin</code></li><li><strong>Suffix operator (<code>*</code>)</strong> - Ex. <code>rue*</code> will return permissions matching the term <code>rue</code> and any additional characters. Useful for matching partial words.</li><li><strong>Phrase operator (<code>""</code>)</strong> - Ex. <code>"Test Engineer II"</code> will return permissions matching the WHOLE phrase <code>"Test Engineer II"</code> exactly</li></ul>',
    searchPlaceholder: "Search by permission name, or permission description.",
    searchResultsCardTitle: "Search Results",
    title: "Permissions",
    userCountMessage: "Please note, there are {userCount} users currently assigned to this permission, they may lose access to Viper on deletion.",
    viewCompletedProjects: "View ALL Completed Projects",
    viewCreateManageInitiatives: "View, create, and manage initiatives.",
    viewSecureCompletedProjects: "View ALL 'Secure' Completed Projects",
    viewSecureProjects: "View ALL projects (secure or not, any status)",
    viperUser: "The base right that every Viper user needs to have.",
    writeAllProjects: "Read and write all projects.",
    writeApprovalWorkFlows: "Can read and write approval workflows.",
    writeBaselineDates: "Read and write all baseline dates",
    writeMyProjects: "Write projects that you are a team member of.",
    writeNotificationGroups: "Read and write all notification groups",
    writePermissions: "Read and write all permissions.",
    writeTemplates: "Can read and write project/milestone templates."
  },
  profile: {
    accountIsHidden: "Account cannot be assigned to projects",
    accountIsNoLongerActive: "Account is no longer active",
    allowOnProjects: "Allow on Projects",
    cannotHidePermissionsExist: "Cannot hide a user with Permissions assigned",
    clearImpersonation: "Stop Impersonating",
    conditionalAccess: "Conditional Access",
    conditionalAccessViewer: {
      adGroupName: "AD Group",
      company: "Company",
      productCategoriesAll: "All Product Categories",
      projectTypes: "Project Type"
    },
    departmentLabel: "Department",
    emailLabel: "Email",
    excludedRoleModalDescription: "Add Excluded Permissions",
    excludedRoleModalHeader: "User Permissions Excluded",
    excludedUserRolesCardTitle: "Permissions Excluded",
    hideUserCheckbox: "Hide User From Suggestions",
    impersonateButton: "Impersonate",
    impersonationAlert: "You are currently impersonating {displayName}.",
    impersonationFailed: "Failed to impersonate user",
    jobTitleLabel: "Job Title",
    loadingRolesErrorMessage: "Unable to retrieve roles. Please try again later.",
    loadingUserErrorMessage: "Unable to retrieve user information. Please try again later.",
    locationLabel: "Location",
    managerLabel: "Manager",
    noExcludedPermissionsAssigned: "No permissions have been excluded.",
    noGroupsAssigned: "No notification groups have been assigned",
    noGroupsExcluded: "No notification groups have been excluded",
    noPermissionsAssigned: "No permissions have been assigned",
    pendingChangesPrompt: "It looks like you were editing something. If you leave before saving, your changes will be lost.",
    permissions: "Permissions",
    phoneLabel: "Phone",
    profileText: "Profile",
    projectRoleViewer: {
      functionalArea: "Functional Area",
      region: "Region",
      role: "Role",
      roleDefaults: "Role Defaults"
    },
    projectRoles: "Project Roles",
    projects: "Projects",
    roleModalDescription: "Add a role by using the search input above",
    roleModalHeader: "Add Role",
    roleSearchPlaceHolder: "Role Name",
    title: "User Profile",
    toggleUserSuccess: "Successfully saved user visibility",
    userRolesCardTitle: "Permissions Assigned"
  },
  project: {
    EMEALabel: "EMEA",
    addUserToTeamError: "Unable to add you to this MS Team at this time. Please try again.",
    addViewers: "Add Viewers",
    addViewersDescription: "Adding a project viewer provides view only access to the project and MS Team, but project viewers are not actively working on the project.",
    americasLabel: "Americas",
    approvers: {
      addApproverField: "Additional Approver",
      additionalApproversButton: "Add Additional Approvers",
      additionalApproversHeader: "Additional Approvers",
      projectLeader: "Project Leader",
      user: "User"
    },
    asiaLabel: "Asia",
    copyProjectTeam: "Duplicate Project Team",
    copyProjectTeamWarning: "The current project already has project team data associated with it, which will be overwritten. Do you want to continue?",
    copyProjectTeamWarningTitle: "Project Team Data Exists",
    coreTeamToggle: "Core Team",
    costBadgeLabel: "Cost",
    description: "Description",
    documents: {
      documentsRequiredAlert: "This milestone requires a document prior to submitting for approval"
    },
    dutyRate: "Duty Rate",
    historyTitle: "History",
    historyViewAll: "View All",
    imageNotSupported: "{fileName} is not supported.",
    images: "Images",
    imagesTitle: "Images",
    intake: "Intake",
    intangibleAccountingStandard: "IAS 38",
    isSecureMessage: "This project is secure",
    lastModified: "Last Modified",
    microsoftTeamsButtonLabel: "Teams App",
    milestonesTitle: "Milestones",
    missingMilestonesMessage: "Milestones will appear when project is moved to 'Active' status.",
    mobileSkuTitle: "SKU",
    myStuffTitle: "My Stuff",
    notApplicable: "N/A",
    notifications: {
      addUsersToNotify: "Add Users to Notify",
      coreTeam: "Core Team",
      groups: "Groups",
      nameInputField: "Name",
      notifiedUsers: "Notified Users",
      notifyToggle: "Notify"
    },
    performanceBadgeLabel: "Performance",
    platformProject: "Platform Project",
    productCategory: "Product Category",
    productLine0: "PL0",
    productLine1: "PL1",
    productLine2: "PL2",
    projectMilestoneDocuments: "project milestone documents",
    projectRequester: "Project Requester",
    projectTeamButtonLabel: "Project Team",
    projectTeamSaveError: "Failed to save project Team",
    projectTeamTitle: "Project Team - {projectNumber} - {projectName}",
    projectType: "Project Type",
    projectViewers: "Project Viewers",
    riskBadgeLabel: "Risk",
    risksAndIssuesTitle: "Risks/Issues",
    scheduleBadgeLabel: "Schedule",
    schedulesTitle: "Schedules",
    setDefaultError: "An error occurred while setting {fileName} as Default",
    setDefaultSuccess: "Successfully set {fileName} as Default",
    sharepointButtonLabel: "Sharepoint",
    skuTitle: "SKU Management",
    status: "Status",
    statusButtonLabel: "Status",
    tabTitle: "{id} - {name}",
    teamCreationInProcess: "MS Team is in the process of being created.  Please try again later.",
    title: "Project",
    tooManyTeams: "Unable to add you to this MS Team as you belong to too many teams.  Go to MS Teams and click 'Leave the team' for one of your teams before trying to join another.",
    upload: "Upload",
    uploadError: "Error Uploading Image.",
    users: "Users",
    view: "View",
    viewCTQProjectLabel: "View in CTQ",
    viewProjectButtonLabel: "View Project",
    vigorTemplatesLabel: "VIGOR Templates"
  },
  projectHistory: {
    columns: {
      changeDescription: "Change",
      comment: "Comment",
      created: "Created",
      createdAt: "Changed",
      createdBy: "Created By",
      createdByDisplayName: "By",
      entityType: "Entity",
      milestone: "Milestone",
      relatedEntityDescription: "Related"
    },
    entityType: "Entity Type",
    entityTypes: {
      Project: "Project",
      ProjectMilestone: "Milestone",
      ProjectMilestoneNotification: "Milestone Notification",
      ProjectMilestoneRole: "Milestone Role",
      ProjectMilestoneSchedule: "Milestone Schedule",
      ProjectMilestoneTask: "Milestone Task",
      ProjectRole: "Project Role",
      ProjectTeamAssignment: "Project Team",
      RegionSpecificProjectRole: "Region Project Role",
      StockKeepingUnit: "SKU",
      WorkflowHistory: "Workflow"
    },
    searchTooltip: "Search by change description, milestone name, entity type, and who made the change.",
    title: "Project History",
    viewViperHistory: "View VIPER History",
    viewVpinHistory: "View VPIN History"
  },
  projectIntake: {
    additionalInformation: "Additional Information",
    approveError: "Error occurred while approving {name}",
    approveSuccess: "Successfully approved {name}",
    create: "Create Intake",
    created: "Intake Created",
    edit: "Edit Intake",
    editNewIntakeRedirect: "Intake can not be directly edited.",
    editNewIntakeRedirectLink: "Click here to view the project's intake and edit instead.",
    editViewProjectIntakeRedirect: "Intake has not been submitted yet.",
    editViewProjectIntakeRedirectLink: "Click here to edit the intake instead.",
    intakeApproval: "Intake Approval",
    intakeApprovalStatus: "Intake Approval Status",
    loadingError: "Failed to load project intake",
    rejectError: "Error occurred while rejecting {name}",
    rejectSuccess: "Successfully rejected {name}",
    requiredFields: "Required Fields",
    save: "Save Intake",
    saved: "Intake Saved.",
    submitted: "Intake Submitted",
    tabTitle: "{id} - {name}",
    title: "Project Intake",
    tooltips: {
      max: "Number must be no greater than {max}",
      min: "Number must be at least {min}",
      minMax: "Number must be between {min} and {max}"
    },
    validationError: "Invalid form data for {fieldNames} field(s), please contact an Administrator.",
    viewApprovalStatus: "Intake Approval Status",
    viewIntake: "Click here to view."
  },
  projectMilestoneTable: {
    accelerated: "Accelerated",
    actual: "Actual",
    actualCurrent: "Actual/Current",
    actualCurrentDate: "Actual/Current Date",
    actualDate: "Actual Date",
    addMilestone: "Add Milestone",
    copy: "Duplicate",
    copyMilestone: "Duplicate Milestone",
    createMilestone: "Create Milestone",
    customDateInput: "Select another date",
    datesDisclaimer: "If Actual and Target dates are both available Actual is displayed",
    datesDisclaimerActualCurrent: "If Actual/Current and Target dates are both available Actual/Current is displayed",
    lastMonth: "Last Month",
    linkToSchedule: "Link to schedule",
    review: "Review Date",
    reviewLabel: "Management Review Dates",
    scheduleA: "Schedule A",
    scheduleB: "Schedule B",
    scheduleC: "Schedule C",
    scheduleD: "Schedule D",
    scheduleE: "Schedule E",
    select: "Select Date",
    selectReviewDate: "Select Review Date",
    target: "Target",
    targetDate: "Target Date"
  },
  projectRoles: {
    action: "Action",
    actionDelete: "Delete this role?",
    addAnotherUser: "Add Another User",
    addDefaultUser: "Add Default User",
    addIntakeApprover: "Add Intake Approver",
    addLimitedListUser: "Add Limited List User",
    addProjectTeam: "Add Project Team",
    addRegionalRole: "Add Regional Role",
    addRegionalRoleDynamic: "Add {region} Role",
    addRegionalRoleError: "Error adding Regional Role",
    addRegionalRoleSuccess: "Successfully added Regional Role",
    addTeam: "Add Team",
    addUser: "Add User",
    addUsers: "Add Users",
    colDefaultFor: "Default User For",
    colDefaultUsers: "Default Users",
    colDefaults: "Defaults",
    colFunctionalAreaName: "Functional Area(s)",
    colIsActive: "Active",
    colLimitedList: "Limited List",
    colName: "Name",
    colProductCategoryFilter: "Product Category Filter",
    colProjectType: "Project Team Default Types",
    colRegion: "Region",
    createRoleError: "Error occurred creating role: {name}",
    createRoleSuccess: "Successfully created role: {name}",
    created: "Created",
    defaultForError: "Multiple users cannot be default for same Product Category.",
    defaultIsRequiredError: "Product Category is required.",
    defaultProjectUsers: "Default Project Users",
    defaultUsersTab: "Default Users",
    deleteRegionalRoleConfirm: "Are you sure you want to delete this regional role?",
    deleteRegionalRoleError: "Error deleting Regional Role",
    deleteRegionalRoleSuccess: "Successfully deleted Regional Role",
    deleteRegionalRoleTitle: "Delete Regional Role",
    details: "Details",
    disableRoleModalTitle: "Disable Project Role",
    disableRoleVerificationWarning: "Are you sure you want to disable this role?",
    duplicateDefaultUser: "This combination already exists for the user {user} for the project type {projectType} and product category {productCategory}",
    duplicateProjectTypeError: "This project type was already added.",
    duplicateRegionRoleError: "This region role already exists.",
    duplicateUserError: " This user was already added.",
    editDefaultUser: "Edit Default User",
    editIntakeApprover: "Edit Intake Approver",
    editProjectTeam: "Edit Project Team",
    editTitle: "Edit Project Role",
    emptyRegionErrorDisplay: "Cannot save regional template role with no region or functional area selected.",
    errorModal: {
      duplicateNameErrorMessage: "A Project Role with this name already exists. Please change the name to save.",
      notSavedTitle: "{projectRoleName} Not Saved",
      unsavedErrorMessage: "You have unsaved changes on this page. Would you like to save all changes?"
    },
    functionalArea: "Functional Area",
    getProjectRoleErrorMessage: "Unable to retrieve project role. Please try again later.",
    getProjectRolesErrorMessage: "Unable to retrieve project roles. Please try again later.",
    hideInactiveRoles: "Hide Inactive",
    includeDeleted: "Include Deleted",
    intakeApproversTab: "Intake Approvers",
    limitedListTab: "Limited List",
    limitedListUsers: "Limited List Users",
    milestoneEditor: "Milestone Editor",
    name: "Name",
    newTitle: "New Project Role",
    productCategory: "Product Category",
    projectRole: "Project Role",
    projectTeamTab: "Project Team",
    projectType: "Project Type",
    purpose: "Purpose",
    purposes: {
      approver: "Approver",
      distribution: "Distribution",
      projectTeam: "Project Team"
    },
    removeAndDeactivatePrompt: "Would you like to remove the role from the locations listed and de-activate the role?",
    roleHasActiveUsages: "There was an error de-activating the role. It is currently being used in the locations listed below.",
    roleHasActiveUsagesWithBlockingErrors: "Locations listed in Red are not able to be removed and de-activated due to the role being the last approver in a Required Approver scenario.",
    saveRoleError: "Error occurred updating role",
    saveRoleSuccess: "Successfully updated role",
    searchHelpText: '<p>Search terms can include name and description</p><p>By default, searches with spaces will treat separate words as AND searches - Ex. <code>ruecker champlin</code> will return groups matching the terms <code>ruecker</code> AND <code>champlin</code>.</p><p>The following modifiers can be used for advanced searching:</p><ul><li><strong>OR operator (<code>||</code>)</strong> - Ex. <code>ruecker||champlin</code> will return groups matching the terms <code>ruecker</code> OR <code>champlin</code></li><li><strong>NOT operator (<code>-</code>)</strong> - Ex. <code>ruecker -champlin</code> will return groups matching the term <code>ruecker</code> but NOT <code>champlin</code></li><li><strong>Suffix operator (<code>*</code>)</strong> - Ex. <code>rue*</code> will return groups matching the term <code>rue</code> and any additional characters. Useful for matching partial words.</li><li><strong>Phrase operator (<code>""</code>)</strong> - Ex. <code>"Test Engineer II"</code> will return groups matching the WHOLE phrase <code>"Test Engineer II"</code> exactly</li></ul>',
    searchPlaceholder: "Search...",
    searchTooltip: "Search by name and functional area.",
    selectUsers: "Select Users",
    showInactiveRoles: "Show Inactive",
    tableTitle: "Project Roles",
    title: "Project Roles",
    updated: "Updated",
    userName: "User Name",
    users: "Users"
  },
  projectStatus: {
    intake: {
      canceled: "Intake Canceled",
      draft: "Intake Draft",
      inApproval: "Intake In Approval",
      onHold: "Intake On Hold"
    },
    project: {
      active: "Project Active",
      canceled: "Project Canceled",
      complete: "Project Complete",
      onHold: "Project On Hold"
    },
    unknown: "Unknown"
  },
  projectTemplate: {
    actions: {
      copy: {
        checkAll: "Check All",
        from: "From",
        projectType: "Project Type",
        selectMilestones: "Select Milestones",
        to: "To"
      },
      copyTemplate: "Duplicate Template"
    },
    colDescription: "Description",
    colIasDesignation: "IAS Designation",
    colPlatformDesignation: "Platform Designation",
    colProjectType: "Project Type",
    colStatus: "Status",
    errorModal: {
      approversRequiredErrorDescription: "The following milestones must have approvers added in order to save this project template.",
      notSavedTitle: "{projectTemplateName} Not Saved",
      unsavedErrorMessage: "You have unsaved changes on this page. Would you like to save all changes?"
    },
    exportMilestones: "Export Milestones",
    pageTitle: "Project Templates",
    tableTitle: "Project Templates"
  },
  projects: {
    addRoleFunctionalAreaLabel: "Functional Area",
    addRoleLabel: "Role",
    deleteIntakeModalDescription: "You cannot undo this action, are you sure you want to proceed?",
    deleteIntakeModalTitle: "Delete Intake confirmation",
    deleteThisRole: "Remove this role from the project?",
    description: "Description",
    dupeProjectType: "Duplicate Project Type",
    estimatedLaunchDate: "Estimated Launch Date",
    goToProject: "Go to Project",
    intakeState: "Intake State",
    intakeType: "Intake Type",
    intangibleAccountingStandard: "IAS Designation",
    missingProjectDescription: "Please enter a Description",
    missingProjectType: "Please enter a Project Type",
    platformDesignation: "Platform Designation",
    platformProject: "Platform Project",
    productCategory: "Product Category",
    productLine0: "PL0",
    productLine1: "PL1",
    productLine2: "PL2",
    project: "project",
    projectLeaders: "Project Leaders",
    projectName: "Project Name",
    projectNumber: "Project Number",
    projectStatuses: "project statuses",
    projectType: "Project Type",
    requestor: "Requestor",
    requestorName: "Name of Requester",
    saveProject: "Save project",
    scheduleNotFound: "Schedule id of {scheduleId} is not an available project schedule.",
    searchTooltip: "Search by Project #, Project Name, Description, Requestor, or Project Leader",
    status: "Status",
    teamAddRole: "Add Role",
    teamAddRoleModalTitle: "Add role to {region}",
    templateType: "Project Template Type",
    title: "Projects"
  },
  regionalProjectLeaderCard: {
    backupProjectLeader: "Backup Project Leader",
    error: "Error updating project leaders.",
    projectLeader: "Project Leader",
    removeSelfDescription: "By removing your own name you will remove all of your Project Leader rights to this project.  Are you sure you want to proceed?",
    removeSelfTitle: "Delete Confirmation",
    success: "Project leaders updated successfully.",
    title: "Project Leaders",
    validationMessage: "At least one project leader must be assigned."
  },
  risksAndIssues: {
    createIssue: "Create Issue",
    createIssueSuccess: "Issue created successfully.",
    updateIssueSuccess: "Issue updated successfully.",
    createRisk: "Create Risk",
    createRiskSuccess: "Risk created successfully.",
    updateRiskSuccess: "Risk updated successfully.",
    deleteIssueModalTitle: "Delete Issue confirmation",
    deleteIssueModalDescription: "You cannot undo this action, are you sure you want to proceed?",
    deleteRiskModalTitle: "Delete Risk confirmation",
    deleteRiskModalDescription: "You cannot undo this action, are you sure you want to proceed?",
    changeToIssue: "Change to Issue",
    changeToIssueSuccess: "Issue created from risk.",
    convertedFromRisk: "CONVERTED FROM RISK",
    convertedFromRiskAlert: "This issue was converted from a Risk and may retain risk-specific fields.",
    linkedToRisk: "Risk",
    editRisk: "Edit Risk",
    newIssue: "New Issue",
    editIssue: "Edit Issue",
    newRisk: "New Risk",
    saveChanges: "Save Changes",
    columns: {
      category: "Category",
      dateIdentified: "Date Identified",
      history: "History (Steps Taken)",
      impact: "Impact",
      nextSteps: "Next Steps",
      owner: "Owner",
      preventativeAction: "Preventative Action",
      priority: "Priority",
      probability: "Probability",
      risk: "Risk",
      issue: "Issue",
      rootCause: "Root Cause",
      status: "Status",
      target: "Target"
    },
    formLabels: {
      description: "Description",
      impactSeverityLevel: "Impact",
      priorityCalculator: "Priority Calculator",
      probabilitySeverityLevel: "Probability",
      prioritySeverityLevel: "Priority",
      projectRiskCategoryId: "Category",
      projectRiskStatusId: "Status",
      projectIssueCategoryId: "Category",
      projectIssueStatusId: "Status",
      projectImpactAreaId: "Impact Area",
      rootCause: "Root Cause",
      ownerId: "Owner",
      preventativeAction: "Preventative Action",
      nextSteps: "Next Steps",
      history: "History",
      dateIdentified: "Date Identified",
      targetCompletionDate: "Target Completion Date"
    },
    formPlaceholders: {
      description: "e.g. Legacy API deprecation ahead of schedule",
      preventativeAction: "Describe the preventative action being taken...",
      rootCause: "Describe the root cause of the issue...",
      nextSteps: "Describe the next steps...",
      history: "Describe the steps taken so far to remediate this...",
      projectImpactAreaId: "Select an impact area"
    },
    severity: {
      critical: 'Critical',
      high: 'High',
      low: 'Low',
      medium: 'Medium',
      urgent: 'Urgent'
    },
    tabs: {
      issues: "Issues",
      risks: "Risks"
    },
    title: "Risks & Issues"
  },
  search: {
    noSearchMessage: "Use the input box above to start searching.",
    noSearchResultsMessage: "No results match the search criteria from above.",
    searchResultsCardTitle: "Search Results"
  },
  sku: {
    actionDelete: "Delete this SKU?",
    description: "You can add up to 10 related SKUs. If you have additional SKUs  beyond 10 please attach a spreadsheet.",
    fieldLabel: "SKU #",
    inputPlaceHolder: "Enter SKU"
  },
  swagger: {
    description: "This is the documentation for the Viper API, The Next-Gen VPIN. All requests will use your session for authentication, unless overridden.",
    inspectBearerTokenButton: "Inspect Auth Bearer Token",
    inspectMetUsersTokenButton: "Inspect MET Users Token",
    note: "Note: You can leave the CompanyCode header parameters for methods to empty to use the session based one.",
    pageTitle: "Swagger API Documentation",
    title: "Swagger API"
  },
  tableFilters: {
    dropDownPlaceholder: "Select an option",
    dropdownFilterTooltip: "Click to select a value",
    searchFilterTooltip: "Click to search",
    userFilterTooltip: "Click to search for a user"
  },
  userReplacement: {
    ReplaceWithBlank: "Replace With Blank",
    colAllowBlank: "Allow Blank",
    colMilestone: "Milestone",
    colMilestoneStatus: "Milestone Status",
    colNAEligible: "N/A Eligible",
    colProductCategory: "Product Category",
    colProjectName: "Project Name",
    colProjectNumber: "Project Number",
    colProjectStatus: "Project Status",
    colProjectType: "Project Type",
    colRole: "Role",
    colRoleType: "Role Type",
    colScheduleName: "Schedule",
    colSecure: "Secure",
    deleteModalDescription: "Are you sure you want to replace the user in the selected item(s)?",
    deleteModalTitle: "User Replace Confirmation",
    error: "Error replacing user",
    exportCsv: "CSV",
    noData: "Search for User to be Replaced",
    notApplicableEligible: "N/A Eligible",
    pageTitle: "User Replacement",
    projectNumber: "Project Number",
    projectNumberRequiredMessage: "Project Number required",
    replaceSelected: "Replace Selected",
    replaceUserWith: "Replace User With",
    replaceWith: "Replace With",
    requiredMessage: "User Required",
    saved: "User replaced successfully",
    searchFor: "Search For",
    setNotApplicable: "Set N/A",
    userField: "User to be Replaced"
  },
  users: {
    colDepartment: "Department",
    colEmail: "Email",
    colJobTitle: "Job Title",
    colLocation: "Location",
    colManager: "Manager",
    colName: "Name",
    colRoles: "Permissions",
    filter: "Filter",
    group: "Group",
    role: "Permission",
    searchResults: "Search Results",
    searchTooltip: "Search by Name, Email, Job Title or Department",
    title: "Users",
    user: "User"
  },
  validationErrors: {
    categoryRequired: "Category is required.",
    fieldTypeRequired: "Field Type is required.",
    formTypeRequired: "Form Type is required.",
    invalidFieldName: "{fieldName} cannot be used as field name.",
    nameRequired: "Name is required.",
    missingRequiredField: "Please enter {fieldName}"
  },
  viewDocument: {
    accessDenied: "Access Denied",
    documentNotFound: "Document Not Found",
    downloadAgain: "Download Again",
    pageTitle: "Download File"
  }
};
